<template>
    <div
        v-if="data.show"
        class="snackbar"
        :class="{
            'snackbar--success': data.status === 'Success',
            'snackbar--error': data.status === 'Error'
        }"
    >
        <span class="snackbar__message">{{ data.message }}</span>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue'

    export default defineComponent({
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        setup() {

        }
    })
</script>
